import { useEffect } from 'react';

import { useTranslation } from '../i18n';

/**
 * Name the tab.
 *
 * An operator works this panel with the clinic panel, a ticket queue and Keycloak
 * open beside it, and every tab said «پارسینا — پنل پلتفرم» regardless of screen,
 * so finding the estate again meant clicking through them.
 *
 * The title is GENERIC on the record page — «کلینیک · …», never the clinic's name.
 * DESIGN-CONCEPT §13.2 keeps entity data out of titles and URLs, and a tab title
 * is the one piece of the UI that survives into screen shares, screenshots and
 * the browser's own history where a name would outlive the session.
 */
export default function useDocumentTitle(titleKey) {
  const { t } = useTranslation();

  useEffect(() => {
    if (!titleKey) return;
    document.title = `${t(titleKey)} · ${t('nav.title.suffix')}`;
  }, [titleKey, t]);
}
